import axios from "axios";

import * as cons from "globalConstants";

// export const protocol = "http";
export const protocol = "https";
export const version = "v2";
export const host = "art-map.co.kr";
// export const host = "localhost";
// export const port = ":8024";
// export const port = ":3001";
// export const baseUri = `${protocol}://${host}${port}/api/${version}`;
export const baseUri = `${protocol}://${host}`;
export const statuses = cons.apiStatuses;
export const rowsPerPage = 30;

export const instance = axios.create({ baseURL: baseUri }); //, withCredentials: true });

instance.interceptors.request.use(function (req) {
   const formData = new FormData();

   const data = req.data || req.params || {};

   Object.keys(data).forEach(function (k) {
      formData.append(k, data[k]);
   });
   req.headers = { "Content-Type": "aplication/json" };
   req.data = formData;
   req.params = formData;

   return req;
});

instance.interceptors.response.use((res) => {
   const code = res.data.result === "ok" ? 200 : 400;
   return {
      // code: res.status,
      code,
      data: res.data,
      ...res.data,
   };
});

export * as artists from "api/artists";
export * as gallerys from "api/gallerys";
export * as temp from "api/temp";
export * as order from "api/order";
